import { render, staticRenderFns } from "./ReviewKafkaHarvester.vue?vue&type=template&id=c32e27a0&"
import script from "./ReviewKafkaHarvester.vue?vue&type=script&lang=ts&"
export * from "./ReviewKafkaHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports